/** One rate on the roster: what they are paid, and whether that is their own
 *  rate or the company default. */
import type { CurrentRate } from '../../../api/staff-pay-rates';
import { formatRateCents } from '../pay-rates/pay-rate-format';

const MUTED = 'text-xs text-stone-500 dark:text-stone-400';

export default function StaffRateCell({
  rate,
  isSalaried,
}: {
  rate: CurrentRate | undefined;
  isSalaried: boolean;
}) {
  if (isSalaried) return <span className={MUTED}>—</span>;
  if (!rate || rate.amountCents === null) {
    return <span className={`${MUTED} italic`}>Not set</span>;
  }
  if (rate.source === 'personal') return <>{formatRateCents(rate.amountCents)}</>;
  return <span className={MUTED}>{`${formatRateCents(rate.amountCents)} (default)`}</span>;
}
